module.exports = __webpack_public_path__ + "img/domain_outline.f85d4c28.svg";